import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { Titles } from '../../components/Titles/Titles';
import { ListBoxWithIcons } from '../../components/ListBoxWithIcons/ListBoxWithIcons';
import { OnboardingFlowContext } from '../../OnboardingFlowContext';

import { OnboardingParams } from '../../types';

import { SleepioWhatsNext } from './SleepioWhatsNext';

import Button from '@/components/Button';
import AnswerQuestionsIcon from '@/assets/AnswerQuestionsIcon.svg';
import BenefitsOfSparkIcon from '@/assets/BenefitsOfSparkIcon.svg';
import DownloadTheAppIcon from '@/assets/DownloadTheAppIcon.svg';
import { getProductName, getCoverageCopyProduct } from '@/utils/productHelpers';

export const CoverageConfirmation: React.FC = () => {
  const { next, onboardingFormData } = useContext(OnboardingFlowContext);
  const { product } = useParams<OnboardingParams>();
  const copyProduct = getCoverageCopyProduct(product);
  const { t } = useTranslation();
  let listBox = (
    <ListBoxWithIcons
      title={t(`coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.list_title`)}
      listItems={[
        {
          icon: AnswerQuestionsIcon,
          listText: t(`coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.list_item0`),
        },
        {
          icon: DownloadTheAppIcon,
          listText: t(`coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.list_item1`),
        },
        {
          icon: BenefitsOfSparkIcon,
          listText: t(`coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.list_item2`),
        },
      ]}
    />
  );

  if (product === 'sleepio') {
    listBox = <SleepioWhatsNext />;
  }

  return (
    <>
      <Titles
        title={t(`coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.title`)}
        subtitle={t(
          `coverage.${copyProduct}.${onboardingFormData.personEnrolling}.coverage_confirmation.subtitle`,
          { productName: getProductName(product) },
        )}
      />
      {listBox}
      <Box sx={{ width: '100%', justifyItems: 'center' }}>
        <Button
          onClick={next}
          color="primary"
          variant="contained"
          data-testid="submit-button"
          style={{
            borderRadius: 100,
          }}
        >
          {t('coverage.next')}
        </Button>
      </Box>
    </>
  );
};
